import { useState } from 'react';

import {
  Button,
  ButtonGroup,
  HStack,
  Stack,
  Text,
} from '@frontend/legacy-components';

import { useViewAndRateMutation } from '../data/queries';
import Rating from '../rating/Rating';

const Footer = ({ isClosable, onBack, onClose, onGoToDrawer, video }) => {
  const [rating, setRating] = useState(video.views?.rating || 0);

  const viewAndRateMutation = useViewAndRateMutation();
  return (
    <Stack
      direction={{ base: 'column', tablet: 'row' }}
      justifyContent="space-between"
      paddingX={4}
      paddingY={3}
      spacing={2}
    >
      <HStack align="center" flex="1 0" spacing={1} width="100%">
        <Text>Was this video helpful?</Text>
        <Rating
          rating={rating}
          scale={5}
          onChange={(newRating) => {
            setRating(newRating);
            viewAndRateMutation.mutate({
              videoId: video.id,
              rating: newRating,
            });
          }}
        />
      </HStack>
      <ButtonGroup
        alignItems="center"
        display="flex"
        justifyContent="flex-end"
        size="lg"
      >
        {isClosable ? (
          <>
            <Button variant="primary" onClick={onBack}>
              Back to Help
            </Button>
          </>
        ) : (
          <>
            <Button variant="secondary" onClick={onGoToDrawer}>
              SEE ALL HELP VIDEOS
            </Button>
            <Button variant="primary" onClick={onClose}>
              GET STARTED
            </Button>
          </>
        )}
      </ButtonGroup>
    </Stack>
  );
};

export default Footer;
